import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/common/Button/Button";
import Content from "components/Content";
import Header from "components/Header";
import { History } from "history";
import * as React from "react";
// @ts-ignore
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Col, Row } from "react-grid-system";
import styled from "styled-components";
import { ThemeProvider } from "themes";
import theme, { GlobalStyle } from "themes/simple-theme";

const StyledHeader = styled(Header)`
  position: relative;
`;

const HeaderButtonContainer = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

const StyledButton = styled(Button)`
  width: 500px;
  margin: 20px 0px;
`;

export interface IProp {
  className?: string;

  history: History;
}

export interface IState {
  accessToken?: string;
}

export default class Manage extends React.Component<IProp, IState> {
  private elements: any;

  constructor(props: IProp) {
    super(props);
    this.state = {
      accessToken: ""
    };
    this.elements = {};
  }
  public componentDidMount() {
    this.syncAccessToken();
  }

  public render() {
    const goBack = () => this.props.history.goBack();
    return (
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyle />
          <div className={this.props.className}>
            <StyledHeader>
              <Row>
                <Col>Manage Tablet</Col>
              </Row>
              <HeaderButtonContainer>
                <a onClick={goBack}>
                  <FontAwesomeIcon
                    icon="times"
                    size="3x"
                    style={{ color: "white", margin: "0px 20px" }}
                  />
                </a>
              </HeaderButtonContainer>
            </StyledHeader>
            <StyledContent>
              <textarea
                style={{ width: 500, height: 300 }}
                ref={e => (this.elements.input = e)}
                onChange={this.onChange}
                value={this.state.accessToken}
              />
              <CopyToClipboard text={this.state.accessToken || ""}>
                <StyledButton secondary>
                  Copy Access Token to clipboard
                </StyledButton>
              </CopyToClipboard>
              <StyledButton secondary onClick={this.saveAccessToken}>
                Save Access Token
              </StyledButton>
              <StyledButton secondary onClick={this.deleteAccessToken}>
                Delete Access Token
              </StyledButton>
            </StyledContent>
          </div>
        </>
      </ThemeProvider>
    );
  }

  private onChange = (e: any) => {
    this.setState({
      accessToken: e.target.value
    });
  };

  private loadAccessToken = () => {
    return localStorage.getItem("accessToken") || "";
  };

  private saveAccessToken = () => {
    localStorage.setItem("accessToken", this.state.accessToken || "");
  };

  private removeTokenFromCache = () => {
    localStorage.removeItem("accessToken");
  };

  private syncAccessToken = () => {
    const accessToken = this.loadAccessToken();
    this.setState({ accessToken });
  };

  private deleteAccessToken = () => {
    this.setState(
      {
        accessToken: ""
      },
      () => this.removeTokenFromCache()
    );
  };
}



// WEBPACK FOOTER //
// ./src/screens/Authorization/manage.tsx